import { render, staticRenderFns } from "./AppSidePanelItem.vue?vue&type=template&id=0db0c857"
import script from "./AppSidePanelItem.vue?vue&type=script&lang=js"
export * from "./AppSidePanelItem.vue?vue&type=script&lang=js"
import style0 from "./AppSidePanelItem.vue?vue&type=style&index=0&id=0db0c857&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports